// import { USER_ROLES } from "../../constants";
import {
  FETCH_REPORT_LIST,
  RESET_REPORT_LIST,
} from "../../constants/action.constants";

const initialState = {
  payload: { limit: 10, total: 0, offset: 0 },
  list: [],
  others: {},
};

const reportListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REPORT_LIST:
      return { list: action.payload, others: action.others };

    case RESET_REPORT_LIST:
      return initialState;
    default:
      return state;
  }
};

export default reportListReducer;
